import { invoiceActionTypes } from './invoiceActionTypes';

const initialState = {
  currentInvoice: null,
  currentServices: null,
  activeServices: [],
  payment: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case invoiceActionTypes.SET_INVOICE:
      return {
        ...state,
        currentInvoice: action.payload
      };
    case invoiceActionTypes.SET_INVOICE_SERVICES:
      return {
        ...state,
        currentServices: action.payload.servicesList
      };
    case invoiceActionTypes.ADD_ACTIVE_SERVICE:
      return {
        ...state,
        activeServices: state.activeServices.concat(action.payload)
      };
    case invoiceActionTypes.REMOVE_ACTIVE_SERVICE:
      return {
        ...state,
        activeServices: state.activeServices.filter(
          s => s.serviceId !== action.payload.serviceId
        )
      };
    case invoiceActionTypes.CHANGE_SERVICE_PRICE: {
      const updatePriceList = state.activeServices.map(service => {
        if (service.serviceId === action.payload.serviceId) {
          service.price = action.payload.newPrice;
        }
        return service;
      });
      return {
        ...state,
        activeServices: updatePriceList
      };
    }
    case invoiceActionTypes.RESET_INVOICE:
      return initialState;

    //──── Update invoice ────────────────────────────────────────────────────────────────────
    case invoiceActionTypes.UPDATE_INVOICE_ROW_VERSION: {
      const copyInvoice = Object.assign({}, state.currentInvoice);
      copyInvoice.rowVersion = action.payload;
      return {
        ...state,
        currentInvoice: copyInvoice
      };
    }
    case invoiceActionTypes.UPDATE_INVOICE_ERROR:
      return state;
    case invoiceActionTypes.UPDATE_INVOICE_SUCCESS:
      return state;

    default:
      return state;
  }
};
